var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#6C01A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6672 26.4993C24.6672 21.9043 28.4055 18.166 33.0005 18.166C37.5955 18.166 41.3338 21.9043 41.3338 26.4993C41.3338 31.0943 37.5955 34.8327 33.0005 34.8327C28.4055 34.8327 24.6672 31.0943 24.6672 26.4993ZM39.8622 36.6178C38.9305 36.3811 37.9172 36.5145 37.0789 36.9811C34.5489 38.3878 31.4521 38.3878 28.9221 36.9811C28.0855 36.5161 27.0705 36.3844 26.1388 36.6178C22.8188 37.4561 20.5005 40.4694 20.5005 43.9444V45.6294C20.5005 46.6927 20.7838 47.7326 21.3221 48.6392C21.7605 49.3759 22.5822 49.8343 23.4638 49.8343H42.5355C43.4172 49.8343 44.2388 49.3776 44.6771 48.6376C45.2155 47.7326 45.4989 46.6927 45.4989 45.6294V43.9444C45.5005 40.4694 43.1822 37.4561 39.8622 36.6178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledProfile);
export default __webpack_public_path__ + "static/media/filledProfile.22ddbbb8.svg";
export { ForwardRef as ReactComponent };